/**
 * 输入校验  支持输入字符串，数组。支持自定义函数。
 * @param {*} value  
 * @param {*} r  'isRequired|isNumber' or ['isRequired', testZero] or  [{test: 'isRequired', msg: '必填'}] 
 */
export function validate(value, r) {
  let rules = typeof r === 'string' ? rules.split('|') : r, error = false;

  (rules || []).forEach(itm => {

    if (error) {
      return;
    }
     
    const rule = Object.prototype.toString.call(itm) === '[object Object]' ? (itm && itm.test) : itm;
    const msg = Object.prototype.toString.call(itm) === '[object Object]' ? (itm && itm.msg) : true;
    const pass = typeof rule === 'function' ? rule(value) : vals.hasOwnProperty(rule) ? vals[rule](value) : true;
    error = pass ? false : msg;

  });
  return error;
}

// 可补充的validations
export const vals = {
  isRequired(data) {
    return !!data.toString();
  },
  isNumber(data) {
    return !isNaN(data);
  }
}




// WEBPACK FOOTER //
// ./client/util/validate.js